import { graphql, useStaticQuery } from 'gatsby';
import { ProductFamily } from '../../../templates/StructuredDataContext';

interface ProductFamilyQuery {
    allKontentItemDataProductFamily: {
        edges: {
            node: ProductFamily;
        }[];
    };
}

export const useProductFamilies = (): ProductFamily[] => {
    const productFamilyData: ProductFamilyQuery = useStaticQuery(graphql`
        {
            allKontentItemDataProductFamily(
                filter: {
                    system: {
                        collection: { eq: "authoring" }
                        workflow_step: { ne: "archived" }
                    }
                }
            ) {
                edges {
                    node {
                        elements {
                            product_family {
                                value {
                                    codename
                                    name
                                }
                            }
                            product_type {
                                value {
                                    codename
                                }
                            }
                            products {
                                value {
                                    ...productPagePreview
                                }
                            }
                            support_products {
                                value {
                                    ...productPagePreview
                                }
                            }
                        }
                        preferred_language
                        id
                    }
                }
            }
        }
    `);

    return productFamilyData.allKontentItemDataProductFamily.edges
        .filter((edge) => {
            return edge.node.preferred_language === 'default';
        })
        .map((edge) => {
            return {
                ...edge.node,
            };
        });
};
